import { Check } from "lucide-react";
import { STAGES, fmtDate } from "@/lib/labels";

const lastAt = (history, i) => [...(history || [])].reverse().find((h) => h.stage === i)?.at;

export const StageBar = ({ stage, cancelled }) => (
  <div className="h-2.5 w-full overflow-hidden rounded-full bg-black/40" data-testid="stage-progress-bar">
    <div className={`h-full rounded-full transition-[width] duration-700 ${cancelled ? "bg-red-400/60" : "bg-gradient-to-l from-[var(--km-pink)] to-[var(--km-lilac)]"}`}
      style={{ width: `${((stage + 1) / STAGES.length) * 100}%` }} />
  </div>
);

export const StageTracker = ({ stage, history, cancelled }) => (
  <ol className="grid gap-4 md:grid-cols-6 md:gap-2" data-testid="stage-tracker">
    {STAGES.map((label, i) => {
      const done = i < stage || (i === stage && i === STAGES.length - 1);
      const current = i === stage && !done;
      const at = i <= stage ? lastAt(history, i) : null;
      const last = i === STAGES.length - 1;
      const seg = i < stage ? "bg-[var(--km-pink)]" : "bg-purple-900/70";
      return (
        <li key={label} className="relative flex items-center gap-3 md:flex-col md:items-center md:text-center" data-testid={`stage-step-${i}`} data-state={done ? "done" : current ? "current" : "todo"}>
          {!last && <span aria-hidden="true" data-testid={`stage-line-${i}`} className={`absolute right-[18px] top-10 h-[calc(100%-1.5rem)] w-1 rounded-full transition-colors duration-500 md:right-1/2 md:left-[calc(-50%-0.5rem)] md:top-[18px] md:h-1 md:w-auto ${seg}`} />}
          <span className={`relative z-10 grid h-10 w-10 shrink-0 place-items-center rounded-full border-2 font-display text-lg transition-colors ${
            cancelled && i === stage ? "border-red-400 bg-red-950 text-red-200"
              : done ? "border-[var(--km-pink)] bg-[var(--km-pink)] text-white"
              : current ? "animate-pulse border-[var(--km-lilac)] bg-[#3a1670] text-white ring-4 ring-[var(--km-lilac)]/30"
              : "border-purple-900 bg-[var(--km-card)] text-purple-300/50"}`}>
            {done ? <Check className="h-5 w-5" /> : i + 1}
          </span>
          <span className="md:px-1">
            <span className={`font-head block text-sm font-bold ${i <= stage ? "text-white" : "text-purple-300/50"}`}>{label}</span>
            {at && <span className="block text-[11px] text-purple-300/70">{fmtDate(at)}</span>}
          </span>
        </li>
      );
    })}
  </ol>
);
